import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = JSX.IntrinsicElements["button"] & {
  theme: "plus" | "removable";
};

const iconMap = {
  plus: "add-more",
  removable: "cross-bold",
};

export const TagButton: FC<Props> = ({ children, className = "", theme, ...rest }) => (
  <button type="button" className={`${styles.wrapper} ${className}`} {...rest}>
    <div className={styles.childrenWrapper}>{children}</div>
    <div className={styles.iconWrapper}>
      <Icon name={iconMap[theme]} />
    </div>
  </button>
);
